/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal request to resolve a rate's refundable status
 * @export
 * @interface RateRefundableRequestV2
 */
export interface RateRefundableRequestV2 {
    /**
     * 
     * @type {number}
     * @memberof RateRefundableRequestV2
     */
    gondolaRateId: number;
}

/**
 * Check if a given object implements the RateRefundableRequestV2 interface.
 */
export function instanceOfRateRefundableRequestV2(value: object): value is RateRefundableRequestV2 {
    if (!('gondolaRateId' in value) || value['gondolaRateId'] === undefined) return false;
    return true;
}

export function RateRefundableRequestV2FromJSON(json: any): RateRefundableRequestV2 {
    return RateRefundableRequestV2FromJSONTyped(json, false);
}

export function RateRefundableRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): RateRefundableRequestV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'gondolaRateId': json['gondola_rate_id'],
    };
}

export function RateRefundableRequestV2ToJSON(json: any): RateRefundableRequestV2 {
    return RateRefundableRequestV2ToJSONTyped(json, false);
}

export function RateRefundableRequestV2ToJSONTyped(value?: RateRefundableRequestV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gondola_rate_id': value['gondolaRateId'],
    };
}

